
import { importSync as i } from '@embroider/macros';
let d = window.define;
d("ember-get-config/index", function(){ return i("ember-get-config/index");});
d("@embroider/macros/es-compat2", function(){ return i("@embroider/macros/es-compat2");});
d("@embroider/macros/runtime", function(){ return i("@embroider/macros/runtime");});
d("ember-gesture-modifiers/modifiers/did-pan", function(){ return i("ember-gesture-modifiers/modifiers/did-pan");});
d("ember-gesture-modifiers/utils/parse-touch-data", function(){ return i("ember-gesture-modifiers/utils/parse-touch-data");});
import "ember-cli-babel/-embroider-implicit-modules.js";
import "ember-concurrency/-embroider-implicit-modules.js";
import "ember-modifier/-embroider-implicit-modules.js";
import "tracked-built-ins/-embroider-implicit-modules.js";
import "tracked-toolbox/-embroider-implicit-modules.js";
import "ember-auto-import/-embroider-implicit-modules.js";
import "ember-get-config/-embroider-implicit-modules.js";
import "ember-cli-htmlbars/-embroider-implicit-modules.js";
import "@embroider/macros/-embroider-implicit-modules.js";
import "ember-gesture-modifiers/-embroider-implicit-modules.js";
import "ember-sinon/-embroider-implicit-modules.js";
